import React from "react";

interface StoreBannerProps {
  image: string;
  alt?: string;
  height?: string;
}

export default function StoreBanner({
  image,
  alt = "Store Banner",
  height = "h-[140px] sm:h-[170px] md:h-[220px] lg:h-[260px]",
}: StoreBannerProps) {
  return (
    <div className="mb-4">
      <div className="w-full border border-gray-200 shadow-sm rounded-lg overflow-hidden bg-white">
        <img
          src={image}
          alt={alt}
          loading="lazy"
          className={`w-full ${height} object-cover`}
        />
      </div>
    </div>
  );
}